<template>
  <div>
    <PrivacyAgreement :show="showAgreePrivacy" @close="handlerCloseAgreePrivacy" />
    <div style="width: 100%; box-sizing: border-box; padding: 10px; display: flex">
      <div ref="homeLeftCol" style="flex: 1; min-width: 0; margin-right: 20px">
        <div class="kpi-strip">
          <div class="kpi-cell kpi-hero">
            <div class="kpi-label">{{ $t("homeHub.salesToday") }}</div>
            <div class="kpi-value vtm-num">
              <i v-if="daySalesLoading" class="el-icon-loading" style="font-size: 20px; color: var(--vtm-ink-3)"></i>
              <span v-else>{{ $currency(daySales.todaySales) }}</span>
            </div>
            <div v-if="!daySalesLoading" class="kpi-delta" :class="salesDeltaPct == null ? 'kpi-delta--flat' : (salesDeltaPct >= 0 ? 'kpi-delta--up' : 'kpi-delta--down')">
              <span v-if="salesDeltaPct == null">—</span>
              <span v-else class="vtm-num">{{ salesDeltaPct >= 0 ? "▲" : "▼" }} {{ Math.abs(salesDeltaPct).toFixed(1) }}%</span>
              <span class="kpi-delta__label">{{ $t("homeHub.vsYesterday") }}</span>
            </div>
          </div>
          <div class="kpi-cell">
            <div class="kpi-label">{{ $t("homeHub.week") }}</div>
            <div class="kpi-value vtm-num">
              <i v-if="daySalesLoading" class="el-icon-loading" style="font-size: 16px; color: var(--vtm-ink-3)"></i>
              <span v-else>{{ $currency(daySales.weekSales) }}</span>
            </div>
          </div>
          <div class="kpi-cell">
            <div class="kpi-label">{{ $t("homeHub.month") }}</div>
            <div class="kpi-value vtm-num">
              <i v-if="daySalesLoading" class="el-icon-loading" style="font-size: 16px; color: var(--vtm-ink-3)"></i>
              <span v-else>{{ $currency(daySales.monthSales) }}</span>
            </div>
          </div>
          <div class="kpi-cell">
            <div class="kpi-label">{{ $t("homeHub.online") }}</div>
            <div class="kpi-value vtm-num">
              <i v-if="machinesLoading" class="el-icon-loading" style="font-size: 16px; color: var(--vtm-ink-3)"></i>
              <span v-else>{{ machines.equipmentMqYesNum || 0 }}/{{ machines.equipmentTotalNum || 0 }}</span>
            </div>
          </div>
        </div>
        <div class="attn-row">
          <div class="attn-chip" :class="{ 'attn-chip--crit': (machines.equipmentMqNoNum || 0) > 0 }" @click="goIf('/machine/user/machine-user')">
            <i class="el-icon-connection attn-chip__icon"></i>
            <span class="attn-chip__count vtm-num">{{ machines.equipmentMqNoNum || 0 }}</span>
            <span class="attn-chip__label">{{ $t("homeHub.offline") }}</span>
          </div>
          <div class="attn-chip" :class="{ 'attn-chip--crit': (alarm.faultNum || 0) > 0 }" @click="goIf('/machine/user/user-machine-alarm')">
            <i class="el-icon-warning-outline attn-chip__icon"></i>
            <span class="attn-chip__count vtm-num">{{ alarm.faultNum || 0 }}</span>
            <span class="attn-chip__label">{{ $t("homeHub.faults") }}</span>
          </div>
          <div class="attn-chip" :class="{ 'attn-chip--warn': (alarm.stockNum || 0) > 0 }" @click="goIf('/machine/user/user-machine-alarm')">
            <i class="el-icon-box attn-chip__icon"></i>
            <span class="attn-chip__count vtm-num">{{ alarm.stockNum || 0 }}</span>
            <span class="attn-chip__label">{{ $t("homeHub.restock") }}</span>
          </div>
          <div class="attn-chip" :class="{ 'attn-chip--warn': refundPending > 0 }" @click="goIf('/order/order-refund')">
            <i class="el-icon-refresh-left attn-chip__icon"></i>
            <span class="attn-chip__count vtm-num">{{ refundPending || 0 }}</span>
            <span class="attn-chip__label">{{ $t("homeHub.refunds") }}</span>
          </div>
        </div>
        <div class="trend-bar">
          <div class="trend-bar__title">{{ $t("consoles.syzxyl") }}</div>
          <div class="trend-bar__controls">
            <span @click="HandlerPSItem(1)" :class="PSItem == 1 ? 'activeyanse' : 'yanse'" class="trend-bar__toggle">{{ $t("consoles.yitian") }}</span>
            <span @click="HandlerPSItem(2)" :class="PSItem == 2 ? 'activeyanse' : 'yanse'" class="trend-bar__toggle">{{ $t("consoles.yizhou") }}</span>
            <span @click="HandlerPSItem(3)" :class="PSItem == 3 ? 'activeyanse' : 'yanse'" class="trend-bar__toggle">{{ $t("consoles.yiyue") }}</span>
            <el-date-picker
              @focus="HandlerPSItem(4)"
              v-model="datastringps"
              size="small"
              clear
              type="datetimerange"
              :range-separator="$t('consoles.zhistr')"
              :start-placeholder="$t('consoles.startdate')"
              :end-placeholder="$t('consoles.enddate')"
              :picker-options="pickerOptions"
              :default-time="['00:00:00', '23:59:59']"
              @change="handlerDatePickerPS"
              style="width: 320px; cursor: pointer"
            ></el-date-picker>
            <el-select
              v-model="weekcondition.searchType"
              @change="HandlerLeixingChange"
              :placeholder="$t('payment.select')"
              size="small"
              style="width: 160px"
            >
              <el-option
                v-for="item in pcOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-link v-if="grants.has('/statistics/date-profit')" type="primary" :underline="false" style="font-size: 13px; white-space: nowrap" @click="$router.push('/statistics/date-profit')">{{ $t("homeHub.viewSales") }} →</el-link>
          </div>
        </div>
        <div
          id="DataVolumeStatistics"
          style="
            padding: 10px;
            margin-top: 15px;
            height: 400px;
            border: 1px solid var(--vtm-line);
            border-radius: 3px;
            font-weight: normal;
          "
        ></div>
        <!-- 分时段销售热力图：星期 × 小时（近7天），找出最赚钱的时段 -->
        <div class="hod-card">
          <div class="hod-card__head">
            <span class="hod-card__title">{{ $t("homeHub.hourTitle") }}</span>
            <span v-if="hodPeak" class="hod-card__peak"><i class="el-icon-data-analysis"></i> {{ $t("homeHub.peakHour") }}: {{ hodPeak }}</span>
            <span class="hod-card__range">{{ $t("homeHub.hodWeek") }}</span>
          </div>
          <div id="hourChart" v-loading="hodLoading" style="width: 100%; height: 320px"></div>
        </div>
      </div>
      <div
        class="home-right-col"
        style="width: 412px; flex-shrink: 0;"
        :style="homeLeftColHeight ? { height: homeLeftColHeight + 'px' } : {}"
      >
        <div class="home-right-card" style="border: 1px solid var(--vtm-line); padding: 15px 15px 0 15px">
          <div style="margin-bottom: 15px; display: flex; align-items: baseline; gap: 8px;">
            <span style="font-weight: bold; font-size: 16px; color: var(--vtm-ink-2)">{{ activeName === 'deliveries' ? $t("consoles.recentDeliveries") : $t("consoles.xsph") }}</span>
            <span v-if="activeName !== 'deliveries' && search.startDate && search.endDate" style="font-size: 11px; color: var(--vtm-ink-3)">{{ search.startDate }} – {{ search.endDate }}</span>
          </div>
          <div v-show="activeName !== 'deliveries'" style="width: 100%; margin-bottom: 15px; display: flow-root">
            <el-select
              v-model="search.sort"
              @change="handlerSortChange"
              size="small"
              :placeholder="$t('payment.select')"
              style="width: 48%; margin-right: 2%"
            >
              <el-option
                v-for="item in pcOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- <el-select v-if="activeName == 'third'" v-model="sbzhi" @change="handlerMachineChange" multiple :placeholder="$t('payment.select')" style="width: 48%; margin-left: 2%;">
              <el-option v-for="item in sbOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select> -->
          </div>
          <el-tabs v-model="activeName" @tab-click="HandleSwitcPage">
            <!-- 最近出货信息流（默认页签） -->
            <el-tab-pane v-loading="deliveriesLoading" :label="$t('consoles.recentDeliveries')" name="deliveries">
              <div
                v-if="!deliveriesLoading && recentDeliveries.length === 0"
                style="text-align: center; padding: 30px 0; color: var(--vtm-ink-3); font-size: 13px"
              >
                {{ $t("common.noData") }}
              </div>
              <div class="deliv-feed">
              <div v-for="(item, index) in recentDeliveries" :key="item.orderNumber || index" class="deliv-row" :style="{ cursor: grants.has('/order/order') ? 'pointer' : 'default' }" @click="goIf('/order/order')">
                <div class="deliv-imgs">
                  <template v-if="dItemCount(item) > 1">
                    <el-image v-for="(g, i) in dItemImages(item)" :key="i" class="deliv-img deliv-img--multi" :src="g" fit="contain">
                      <div slot="error" class="deliv-ph"><i class="el-icon-goods"></i></div>
                      <div slot="placeholder" class="deliv-ph"><i class="el-icon-goods"></i></div>
                    </el-image>
                  </template>
                  <el-image v-else class="deliv-img" :src="dImage(item)" fit="contain">
                    <div slot="error" class="deliv-ph"><i class="el-icon-goods"></i></div>
                    <div slot="placeholder" class="deliv-ph"><i class="el-icon-goods"></i></div>
                  </el-image>
                </div>
                <div class="deliv-meta">
                  <div class="deliv-name">{{ dName(item) }}</div>
                  <div class="deliv-sub">{{ item.equipmentName || item.equipmentNo }}</div>
                </div>
                <div class="deliv-right">
                  <div class="deliv-amt vtm-num">{{ $currency(item.payablePrice) }}</div>
                  <div class="deliv-time vtm-num">{{ $formatDate(item.buyTime) }}</div>
                  <div class="deliv-relt">{{ relTime(item.buyTime) }}</div>
                </div>
              </div>
              </div>
            </el-tab-pane>
            <el-tab-pane v-loading="loading" :label="$t('consoles.sbb')" name="first">
              <div
                v-for="(item, index) in datasets"
                :key="index"
                style="
                  display: flow-root;
                  background-color: var(--vtm-surface);
                  border-radius: var(--vtm-r-md);
                  box-shadow: var(--vtm-e1);
                  border: 1px solid var(--vtm-line);
                  padding: 15px;
                  margin-bottom: 15px;
                "
              >
                <div style="display: flow-root; margin-bottom: 15px">
                  <div>{{ $t("consoles.sbm") }}：{{ item["equipmentName"] }}</div>
                  <div>{{ $t("consoles.sbh") }}：<span class="vtm-mono">{{ item["equipmentNo"] }}</span></div>
                </div>
                <div style="display: flex; width: 100%">
                  <div style="display: flow-root; text-align: center; width: 50%">
                    <div class="vtm-num" style="font-size: 16px">{{ $currency(item["sales"]) }}</div>
                    <div style="font-size: 10px">
                      {{ $t("consoles.xse") }}
                    </div>
                  </div>
                  <div style="display: flow-root; text-align: center; width: 50%">
                    <div class="vtm-num" style="font-size: 16px">{{ item["num"] }}</div>
                    <div style="font-size: 10px">
                      {{ $t("consoles.xsl") }}
                    </div>
                  </div>
                  <div style="display: flow-root; text-align: center; width: 50%">
                    <div class="vtm-num" style="font-size: 16px">{{ $currency(item["cost"]) }}</div>
                    <div style="font-size: 10px">
                      {{ $t("consoles.zcb") }}
                    </div>
                  </div>
                  <div style="display: flow-root; text-align: center; width: 50%">
                    <div class="vtm-num" style="font-size: 16px">
                      {{ $currency(item["profit"]) }}
                    </div>
                    <div style="font-size: 10px">
                      {{ $t("consoles.zlr") }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="ismore == 1"
                @click="getSalesMachine(page.pageIndex)"
                style="
                  margin-bottom: 15px;
                  text-align: center;
                  font-size: 14px;
                  color: var(--vtm-ink-2);
                  cursor: pointer;
                  text-decoration: underline;
                "
              >
                {{ $t("consoles.loadMore") }}
              </div>
              <div v-if="ismore == 0" style="margin-bottom: 15px; text-align: center; font-size: 14px; color: var(--vtm-ink-2)">
                {{ $t("consoles.qianwu") }}
              </div>
              <div v-if="ismore == 2" style="margin-bottom: 15px; text-align: center; font-size: 14px; color: var(--vtm-ink-2)">
                {{ $t("consoles.loading") }}
              </div>
            </el-tab-pane>
            <el-tab-pane v-loading="loading" :label="$t('consoles.spb')" name="second">
              <div id="ProductChart" style="width: 100%; height: 300px"></div>
              <div
                v-for="(item, index) in datasets"
                :key="index"
                style="
                  display: flex;
                  background-color: var(--vtm-surface);
                  border-radius: var(--vtm-r-md);
                  box-shadow: var(--vtm-e1);
                  border: 1px solid var(--vtm-line);
                  padding: 15px;
                  margin-bottom: 15px;
                "
              >
                <div style="width: 44%">{{ item["goodsName"] }}</div>
                <div style="width: 48%">
                  <div style="display: flex; width: 100%; margin-bottom: 10px">
                    <div style="display: flow-root; text-align: center; width: 50%">
                      <div class="vtm-num" style="font-size: 16px">
                        {{ $currency(item["sales"]) }}
                      </div>
                      <div style="font-size: 10px">
                        {{ $t("consoles.xse") }}
                      </div>
                    </div>
                    <div style="display: flow-root; text-align: center; width: 50%">
                      <div class="vtm-num" style="font-size: 16px">{{ item["num"] }}</div>
                      <div style="font-size: 10px">
                        {{ $t("consoles.xsl") }}
                      </div>
                    </div>
                  </div>
                  <div style="display: flex; width: 100%; margin-top: 10px">
                    <div style="display: flow-root; text-align: center; width: 50%">
                      <div class="vtm-num" style="font-size: 16px">
                        {{ $currency(item["cost"]) }}
                      </div>
                      <div style="font-size: 10px">
                        {{ $t("consoles.zcb") }}
                      </div>
                    </div>
                    <div style="display: flow-root; text-align: center; width: 50%">
                      <div class="vtm-num" style="font-size: 16px">
                        {{ $currency(item["profit"]) }}
                      </div>
                      <div style="font-size: 10px">
                        {{ $t("consoles.zlr") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="ismore == 1"
                @click="getSalesProduct(page.pageIndex)"
                style="
                  margin-bottom: 15px;
                  text-align: center;
                  font-size: 14px;
                  color: var(--vtm-ink-2);
                  cursor: pointer;
                  text-decoration: underline;
                "
              >
                {{ $t("consoles.loadMore") }}
              </div>
              <div v-if="ismore == 0" style="margin-bottom: 15px; text-align: center; font-size: 14px; color: var(--vtm-ink-2)">
                {{ $t("consoles.qianwu") }}
              </div>
              <div v-if="ismore == 2" style="margin-bottom: 15px; text-align: center; font-size: 14px; color: var(--vtm-ink-2)">
                {{ $t("consoles.loading") }}
              </div>
            </el-tab-pane>
            <!-- 用户榜（third）已移除：绝大多数经销商为单账号，无需自见排行榜 -->
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as echarts from "echarts";
  import { grantedLinks } from "@/utils/navSections";
  // import Intercom from "@intercom/messenger-js-sdk";
  import PrivacyAgreement from "@/components/PrivacyAgreement";
  let xAxisData = [];
  let DataVolumeStatistics = null;
  let hourChart = null;
  let ProductChart = null;
  // 最近一次热力图数据，切换亮/暗主题时直接重绘，无需重新请求
  let lastHourHeatmap = null;
  export default {
    name: "Main",
    data() {
      return {
        activeName: "deliveries",
        // 右侧「最近销售」列的显式高度（px）：与左侧堆叠图表的实际渲染高度同步，
        // 而非依赖 flex stretch（右侧内容自身高度会影响该行的拉伸基准，导致溢出）。
        homeLeftColHeight: null,
        recentDeliveries: [],
        deliveriesLoading: false,
        machines: {},
        daySales: {},
        alarm: {},
        machinesLoading: true,
        daySalesLoading: true,
        alarmLoading: true,
        datasets: [],
        search: {
          equipmentNo: "",
          startDate: "",
          endDate: "",
          sort: "sales",
          order: "desc"
        },
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        ismore: 2,
        SearchDataString: "",
        loading: false,
        pcOptions: [
          {
            value: "num",
            label: this.$t("consoles.axl")
          },
          {
            value: "sales",
            label: this.$t("consoles.axse")
          }
        ],
        sbOptions: [
          {
            value: "num",
            label: this.$t("consoles.axl")
          },
          {
            value: "sales",
            label: this.$t("consoles.axse")
          }
        ],
        sbzhi: "num",
        //  近一周销售量、销售额统计
        datastringps: "",
        pickerOptions: {
          shortcuts: [
            {
              text: this.$t("TimeControl.week"),
              onClick(picker) {
                const end = new Date();
                end.setHours(23, 59, 59, 999);
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: this.$t("TimeControl.month"),
              onClick(picker) {
                const end = new Date();
                end.setHours(23, 59, 59, 999);
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: this.$t("TimeControl.year"),
              onClick(picker) {
                const end = new Date();
                end.setHours(23, 59, 59, 999);
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              }
            }
          ]
        },
        PSItem: 1,
        weekcondition: {
          startDate: "",
          endDate: "",
          searchType: "sales", // num：销售量  sales：销售额
          type: 2
        },
        weekconditionpc: {
          startDate: "",
          endDate: ""
        },
        showAgreePrivacy: false,
        refundPending: 0,
        deliveriesTimer: null,
        // 分时段销售热力图（近7天：星期 × 小时）
        hodLoading: false,
        hodPeak: ""
      };
    },
    components: {
      PrivacyAgreement
    },
    watch: {
      // 图表颜色在 setOption 时写死，切换主题后需要按新配色重绘
      "$store.state.theme"() {
        this.$nextTick(() => {
          this.BrokenLineStatisticsChart();
          if (lastHourHeatmap) {
            this.renderHourHeatmap(...lastHourHeatmap);
          }
        });
      }
    },
    computed: {
      // 已授权页面 link 集合：深链仅在目标页已授权时导航（子账号菜单可能较少）
      grants() {
        return grantedLinks(this.$store.state.menuList);
      },
      // Sales-today vs yesterday, as a percent delta; null when there's no yesterday baseline.
      salesDeltaPct() {
        const today = Number(this.daySales.todaySales) || 0;
        const yesterday = Number(this.daySales.yesterdaySales) || 0;
        if (!yesterday) {
          return null;
        }
        return ((today - yesterday) / yesterday) * 100;
      },
    },
    mounted() {
      let _self = this;
      // 是否展示隐私协议
      if (String(this.$route.query.showAgreePrivacy) === '0') {
        this.showAgreePrivacy = true;
        this.$store.commit('set', { privacyVisible: true });
      }
      DataVolumeStatistics = echarts.init(document.getElementById("DataVolumeStatistics"), "macarons");
      hourChart = echarts.init(document.getElementById("hourChart"), "macarons");
      ProductChart = echarts.init(document.getElementById("ProductChart"), "macarons", {
        width: 416
      });
      //  获取设备数量
      _self.getMachines();
      //  今日销售额
      _self.getDaySales();
      //  待办事宜
      _self.getAlarm();
      //  最近出货信息流（默认页签）
      _self.loadRecentDeliveries();
      _self.deliveriesTimer = setInterval(() => {
        if (_self.activeName === "deliveries") {
          _self.loadRecentDeliveries();
        }
      }, 15000);
      //  分时段销售热力图 + refunds-pending attention chip
      _self.loadHourOfDay();
      _self.loadRefundPending();
      // 右侧「最近销售」列高度与左侧堆叠图表实际高度同步
      _self.$nextTick(_self.syncHomeLeftColHeight);
      window.addEventListener("resize", _self.syncHomeLeftColHeight);
      //  前7天 — line chart, pies, and rankings share this range (top date picker)
      var flag = 1;
      var dateTemp;
      var myDate = new Date(); //获取今天日期
      var startDate = "";
      var endDate = "";
      myDate.setDate(myDate.getDate() - 7);
      for (var i = 0; i < 7; i++) {
        myDate.setDate(myDate.getDate() + flag);
        var year = myDate.getFullYear();
        var month = myDate.getMonth() + 1;
        if (parseInt(month) < 10) {
          month = "0" + month;
        }
        var date = myDate.getDate();
        if (parseInt(date) < 10) {
          date = "0" + date;
        }
        //  底部菜单-获取周几
        dateTemp = year + "-" + month + "-" + date;
        if (i == 0) {
          //  开始日期
          startDate = dateTemp;
        } else if (i == 6) {
          //  结束日期
          endDate = dateTemp;
        }
      }
      _self.PSItem = 2;
      _self.weekcondition.startDate = startDate;
      _self.weekcondition.endDate = endDate;
      _self.datastringps = [new Date(startDate + " 00:00:00"), new Date(endDate + " 23:59:59")];
      _self.BrokenLineStatisticsChart();
      _self.applyTopDashboardDateRange();
    },
    beforeDestroy() {
      if (this.deliveriesTimer) {
        clearInterval(this.deliveriesTimer);
      }
      window.removeEventListener("resize", this.syncHomeLeftColHeight);
    },
    methods: {
      // 读取左侧堆叠图表列的实际渲染高度，供右侧「最近销售」列显式对齐
      syncHomeLeftColHeight() {
        const el = this.$refs.homeLeftCol;
        if (el) {
          this.homeLeftColHeight = el.offsetHeight;
        }
      },
      // 仅当目标页在用户菜单中已授权时才导航（未授权路由不存在，push 会落到空白页）
      goIf(link) {
        if (this.grants.has(link)) {
          this.$router.push(link);
        }
      },
      handlerCloseAgreePrivacy() {
        this.showAgreePrivacy = false;
        this.$store.commit('set', { privacyVisible: false });
      },
      //  按类型统计
      HandlerLeixingChange(e) {
        let _self = this;
        _self.weekcondition.searchType = e;
        _self.BrokenLineStatisticsChart();
      },
      //  Earnings Trend Preview时间选择
      handlerDatePickerPS(e) {
        let _self = this;
        if (!e || !e.length) {
          return;
        }
        var startDate = e[0];
        startDate = _self.GetStandardStrTime(startDate);
        var endDate = e[1];
        endDate = _self.GetStandardStrTime(endDate);
        _self.weekcondition.startDate = startDate;
        _self.weekcondition.endDate = endDate;
        _self.BrokenLineStatisticsChart();
        _self.applyTopDashboardDateRange();
      },
      /** Sync profit pies + rankings to top bar date range (weekcondition / datastringps). */
      applyTopDashboardDateRange() {
        const _self = this;
        _self.weekconditionpc.startDate = _self.weekcondition.startDate;
        _self.weekconditionpc.endDate = _self.weekcondition.endDate;
        if (Array.isArray(_self.datastringps) && _self.datastringps.length === 2 && _self.datastringps[0] && _self.datastringps[1]) {
          _self.search.startDate = _self.GetStandardStrTimes(_self.datastringps[0]);
          _self.search.endDate = _self.GetStandardStrTimes(_self.datastringps[1]);
          _self.SearchDataString = [new Date(_self.datastringps[0]), new Date(_self.datastringps[1])];
        } else if (_self.weekcondition.startDate && _self.weekcondition.endDate) {
          const s = _self.weekcondition.startDate + " 00:00:00";
          const e = _self.weekcondition.endDate + " 23:59:59";
          _self.search.startDate = _self.GetStandardStrTimes(new Date(s));
          _self.search.endDate = _self.GetStandardStrTimes(new Date(e));
          _self.SearchDataString = [new Date(s), new Date(e)];
        }
        if (_self.activeName == "first") {
          _self.getSalesMachine();
        } else if (_self.activeName == "second") {
          _self.getSalesProduct();
          _self.getUserMachine();
        } else if (_self.activeName == "third") {
          _self.getSalesUser();
        }
      },
      //  中国标准时间转时间字符串
      GetStandardStrTime(nS) {
        //  获取一个时间对象
        var date = new Date(nS);
        //  获取完整的年份(4位,1970)
        let y = date.getFullYear();
        //  获取月份(0-11,0代表1月,用的时候记得加上1)
        let m = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        //  获取日(1-31)
        let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        return y + "-" + m + "-" + d;
      },
      //  获取统计图数据
      BrokenLineStatisticsChart() {
        let _self = this;
        DataVolumeStatistics.showLoading();
        //  获取配置信息
        let url = this.$url.Consoles.getSalesDay;
        let method = this.$method.get;
        _self.$api
          .request(url, method, _self.weekcondition)
          .then(res => {
            if (res.code === 0) {

              var result = res.data;
              const metricTitleDvs = _self.weekcondition.searchType === "sales"
                ? _self.$t("MachineProfit.xshoue")
                : _self.$t("MachineProfit.xsliang");
              if (!result || result.length === 0) {
                DataVolumeStatistics.clear();
                DataVolumeStatistics.setOption(_self.emptyChartOption(metricTitleDvs));
                DataVolumeStatistics.hideLoading();
                return;
              }
              let PSItem = parseInt(_self.PSItem);
              let seriesData = [];
              let xAxisData = [];
              for (let i = 0; i < result.length; i++) {
                let amount = result[i][_self.weekcondition.searchType];
                seriesData.push(amount);
                if (PSItem == 1) {
                  let orderDate = result[i]["orderDate"];
                  xAxisData.push(orderDate);
                } else if (PSItem == 2) {
                  let orderDate = result[i]["orderDate"];
                  let zhouji = _self.StringChangeWeek(orderDate);
                  xAxisData.push(orderDate + " " + zhouji);
                } else {
                  xAxisData.push(result[i]["orderDate"]);
                }
              }
              const metricTitle =
                _self.weekcondition.searchType === "sales"
                  ? _self.$t("MachineProfit.xshoue")
                  : _self.$t("MachineProfit.xsliang");
              var series = [
                {
                  name: metricTitle,
                  type: "line",
                  stack: "Total",
                  data: seriesData,
                  areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "rgba(116, 214, 179, 0.35)" },
                      { offset: 1, color: "rgba(116, 214, 179, 0.02)" }
                    ])
                  }
                }
              ];
              const textMsg = metricTitle;
              const pal = _self.chartPalette();
              var chartoption = {
                title: {
                  text: textMsg,
                  textStyle: { color: pal.heading }
                },
                backgroundColor: pal.bg,
                tooltip: {
                  ...pal.tooltip,
                  trigger: "axis",
                  formatter: function(params) {
                    const isSales = _self.weekcondition.searchType === "sales";
                    let result = params[0].axisValueLabel + "<br/>";
                    params.forEach(function(p) {
                      result += p.marker + p.seriesName + ": " + (isSales ? _self.$currency(p.value) : p.value) + "<br/>";
                    });
                    return result;
                  }
                },
                grid: {
                  left: "3%",
                  right: "4%",
                  bottom: "3%",
                  containLabel: true
                },
                toolbox: {
                  feature: {
                    saveAsImage: { backgroundColor: pal.imageBg }
                  }
                },
                xAxis: {
                  type: "category",
                  boundaryGap: false,
                  data: xAxisData,
                  axisLabel: { color: pal.label },
                  axisLine: { lineStyle: { color: pal.line } }
                },
                yAxis: {
                  type: "value",
                  splitLine: { lineStyle: { color: pal.splitLine } },
                  axisLabel: {
                    color: pal.label,
                    formatter: function(value) {
                      return _self.weekcondition.searchType === "sales" ? "$" + value.toLocaleString("en-US") : value;
                    }
                  }
                },
                series: series
              };
              // 绘制图表
              DataVolumeStatistics.clear();
              chartoption && DataVolumeStatistics.setOption(chartoption);
              DataVolumeStatistics.hideLoading();
            }
          })
          .catch(err => {
            this.$notify({
              title: this.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      //  获取占位图数据
      // 图表配色：跟随 <html data-theme>，亮色保持 macarons 原值，暗色取设计令牌
      chartPalette() {
        const root = document.documentElement;
        const dark = root.getAttribute("data-theme") === "dark";
        const css = getComputedStyle(root);
        const token = (name, fallback) => (css.getPropertyValue(name) || "").trim() || fallback;
        const mint = token("--vtm-mint", "#01e1a8");
        if (!dark) {
          return {
            bg: "#FFFFFF",
            imageBg: "#FFFFFF",
            heading: "#1a1f36",
            label: "#6b7280",
            line: "#e4e7ec",
            splitLine: "#f3f4f6",
            splitArea: null,
            heatColors: ["#f0f5f3", mint, "#0b7a5c"],
            tooltip: {}
          };
        }
        const surface = token("--vtm-surface", "#13273b");
        const line = token("--vtm-line", "#23405c");
        return {
          bg: "transparent",
          imageBg: surface,
          heading: token("--vtm-heading", "#f2f6fa"),
          label: token("--vtm-ink-2", "#94a9bd"),
          line: line,
          splitLine: line,
          splitArea: ["rgba(255, 255, 255, 0.02)", "rgba(255, 255, 255, 0)"],
          // 暗底上由深到亮：空格子贴近卡片底色，销量越高越亮
          heatColors: [token("--vtm-well", "#1c344e"), "#0b7a5c", mint],
          tooltip: {
            backgroundColor: token("--vtm-surface-2", "#172d44"),
            borderColor: line,
            textStyle: { color: token("--vtm-ink", "#dbe4ee") }
          }
        };
      },
      emptyChartOption(title) {
        return {
          title: { text: title || "", left: "center", textStyle: { color: this.chartPalette().heading } },
          graphic: {
            type: "text",
            left: "center",
            top: "middle",
            style: { text: "No data available", fontSize: 14, fill: "#999" }
          },
          series: []
        };
      },
      //  字符串转周几
      StringChangeWeek(datestring) {
        let _self = this;
        // 确保使用 UTC 时间创建日期，避免时区影响
        const date = new Date(datestring + "T00:00:00Z");
        const weekNum = date.getUTCDay(); //获取今天是周几
        const week = {
          0: _self.$t("consoles.zhouri"),
          1: _self.$t("consoles.zhouyi"),
          2: _self.$t("consoles.zhouer"),
          3: _self.$t("consoles.zhousan"),
          4: _self.$t("consoles.zhousi"),
          5: _self.$t("consoles.zhouwu"),
          6: _self.$t("consoles.zhouliu")
        };
        return week[weekNum] ?? "Date Error";
      },
      //  Earnings Trend Preview
      HandlerPSItem(type) {
        let _self = this;
        //  获取今天日期
        let myDate = new Date();
        // Declare common variables at function level to avoid duplicates
        var flag, dateTemp, startDate, endDate, year, month, day, hour, minute, second, i, enddatetime, startdatetime;
        if (parseInt(type) === 1) {
          //  当前时间年月日时分秒
          year = myDate.getFullYear();
          month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          enddatetime = year + "-" + month + "-" + day + " " + hour + ":00:00";
          //  昨天的时间
          myDate.setTime(myDate.getTime() - 24 * 60 * 60 * 1000);
          year = myDate.getFullYear();
          month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          //  获取统计数据
          startdatetime = year + "-" + month + "-" + day + " " + hour + ":00:00";
          _self.datastringps = [new Date(startdatetime), new Date(enddatetime)];
          _self.weekcondition.startDate = startdatetime;
          _self.weekcondition.endDate = enddatetime;
          _self.weekcondition.type = 1;
          _self.BrokenLineStatisticsChart();
        } else if (parseInt(type) === 2) {
          flag = 1;
          dateTemp = "";
          startDate = "";
          endDate = "";
          myDate.setDate(myDate.getDate() - 7);
          for (i = 0; i < 7; i++) {
            myDate.setDate(myDate.getDate() + flag);
            year = myDate.getFullYear();
            month = myDate.getMonth() + 1;
            if (parseInt(month) < 10) {
              month = "0" + month;
            }
            var date = myDate.getDate();
            if (parseInt(date) < 10) {
              date = "0" + date;
            }
            //  底部菜单-获取周几
            dateTemp = year + "-" + month + "-" + date;
            if (i === 0) {
              //  开始日期
              startDate = dateTemp;
            } else if (i === 6) {
              //  结束日期
              endDate = dateTemp;
            }
          }
          //  获取统计数据
          _self.datastringps = [new Date(startDate + " 00:00:00"), new Date(endDate + " 23:59:59")];
          _self.weekcondition.startDate = startDate;
          _self.weekcondition.endDate = endDate;
          _self.weekcondition.type = 2;
          _self.BrokenLineStatisticsChart();
        } else if (parseInt(type) === 3) {
          flag = 1;
          dateTemp = "";
          startDate = "";
          endDate = "";
          myDate.setDate(myDate.getDate() - 30);
          for (i = 0; i < 30; i++) {
            myDate.setDate(myDate.getDate() + flag);
            year = myDate.getFullYear();
            month = myDate.getMonth() + 1;
            if (parseInt(month) < 10) {
              month = "0" + month;
            }
            var date = myDate.getDate();
            if (parseInt(date) < 10) {
              date = "0" + date;
            }
            //  底部菜单-获取周几
            dateTemp = year + "-" + month + "-" + date;
            if (i === 0) {
              //  开始日期
              startDate = dateTemp;
            } else if (i === 29) {
              //  结束日期
              endDate = dateTemp;
            }
          }
          //  获取统计数据
          _self.datastringps = [new Date(startDate + " 00:00:00"), new Date(endDate + " 23:59:59")];
          _self.weekcondition.startDate = startDate;
          _self.weekcondition.endDate = endDate;
          _self.weekcondition.type = 2;
          _self.BrokenLineStatisticsChart();
        } else if (parseInt(type) === 4) {
          if (_self.PSItem === 1) {
            //  当前时间年月日时分秒
            year = myDate.getFullYear();
            month = myDate.getMonth() + 1;
            if (parseInt(month) < 10) {
              month = "0" + month;
            }
            day = myDate.getDate();
            if (parseInt(day) < 10) {
              day = "0" + day;
            }
            enddatetime = year + "-" + month + "-" + day;
            //  昨天的时间
            myDate.setTime(myDate.getTime() - 24 * 60 * 60 * 1000);
            year = myDate.getFullYear();
            month = myDate.getMonth() + 1;
            if (parseInt(month) < 10) {
              month = "0" + month;
            }
            day = myDate.getDate();
            if (parseInt(day) < 10) {
              day = "0" + day;
            }
            //  获取统计数据
            startdatetime = year + "-" + month + "-" + day;
            _self.datastringps = [new Date(startdatetime + " 00:00:00"), new Date(enddatetime + " 23:59:59")];
            _self.weekcondition.startDate = startdatetime;
            _self.weekcondition.endDate = enddatetime;
          }
          _self.weekcondition.type = 2;
        }
        _self.PSItem = type;
        if (parseInt(type) !== 4) {
          _self.applyTopDashboardDateRange();
        }
      },
      //  获取设备数量
      getMachines() {
        let _self = this;
        // Use proper dashboard API for real-time machine counts
        let url = this.$url.Consoles.getMachine;
        let method = this.$method.get;
        this.$api
          .request(url, method, {})
          .then(res => {
            if (res.code === 0) {
              // Use backend data directly - no frontend calculation needed
              _self.machines = res.data;
            }
            _self.machinesLoading = false;
          })
          .catch(err => {
            // Fallback to user equipment API if dashboard API fails
            console.warn('Dashboard API failed, falling back to user equipment API:', err);
            let fallbackUrl = this.$url.UserMachine.page;
            let params = {
              pageSize: 100,
              pageIndex: 1
            };
            this.$api
              .request(fallbackUrl, method, params)
              .then(res => {
                if (res.code === 0) {
                  // Transform user equipment response to dashboard format
                  let response = {
                    equipmentTotalNum: res.data.total || 0,
                    equipmentMqYesNum: 0, // Count online machines
                    equipmentMqNoNum: 0   // Count offline machines
                  };
                  
                  // Count online/offline machines if records available
                  if (res.data.records && res.data.records.length > 0) {
                    res.data.records.forEach(machine => {
                      if (machine.mqState === 1 || machine.mqState === '1') {
                        response.equipmentMqYesNum++;
                      } else {
                        response.equipmentMqNoNum++;
                      }
                    });
                    // If we only got partial records, estimate based on total
                    if (res.data.total > res.data.records.length) {
                      let ratio = res.data.records.length / res.data.total;
                      response.equipmentMqYesNum = Math.round(response.equipmentMqYesNum / ratio);
                      response.equipmentMqNoNum = response.equipmentTotalNum - response.equipmentMqYesNum;
                    }
                  }
                  
                  _self.machines = response;
                  _self.machinesLoading = false;
                }
              })
              .catch(fallbackErr => {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: fallbackErr.msg,
                  type: "error"
                });
              });
          });
      },
      //  今日销售额
      getDaySales() {
        let _self = this;
        //  获取配置信息
        let url = this.$url.Consoles.getSales;
        let method = this.$method.get;
        this.$api
          .request(url, method, {})
          .then(res => {
            if (res.code === 0) {
              _self.daySales = res.data;
            }
            _self.daySalesLoading = false;
          })
          .catch(err => {
            _self.daySalesLoading = false;
            this.$notify({
              title: this.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
            },
      //  待办事宜
      getAlarm() {
        let _self = this;
        let url = this.$url.Consoles.getAlarm;
        let method = this.$method.get;
        this.$api
          .request(url, method, {})
          .then(res => {
            if (res.data) {
              _self.alarm = res.data;
            }
            _self.alarmLoading = false;
          })
          .catch(err => {
            this.$notify({
              title: this.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      //  排行榜Tab切换（按 name 切换，避免新增页签后索引错位）
      HandleSwitcPage(tab) {
        let _self = this;
        if (tab.name === "deliveries") {
          _self.loadRecentDeliveries();
        } else if (tab.name === "first") {
          _self.getSalesMachine();
        } else if (tab.name === "second") {
          _self.getSalesProduct();
          _self.getUserMachine();
        } else if (tab.name === "third") {
          _self.getSalesUser();
        }
      },
      //  分时段销售热力图：近7天小时级数据，一次请求取完整区间（dashboard/sales/day type=3）
      //  type=3 = 按小时聚合但 orderDate 保留日期（"yyyy-MM-dd HH:00:00"），这样一次查询就能拆出
      //  「哪一天 × 哪个小时」；type=1 只回 "HH:mm"，多日区间会把 7 天糊在一起，才需要逐日请求。
      //  不传 searchType：SQL 只在 searchType 为空时才同时返回 num/sales/profit，
      //  传 "sales" 会导致 num 缺失、tooltip 的销量恒为 0。
      loadHourOfDay() {
        let _self = this;
        const days = [];
        for (let i = 6; i >= 0; i--) {
          const d = new Date();
          d.setDate(d.getDate() - i);
          days.push(d);
        }
        // 日期字符串 → days 下标，用于把返回行放回对应的行
        const dayIndex = {};
        days.forEach((d, i) => {
          dayIndex[_self.GetStandardStrTime(d)] = i;
        });
        _self.hodLoading = true;
        _self.$api
          .request(_self.$url.Consoles.getSalesDay, _self.$method.get, {
            startDate: _self.GetStandardStrTime(days[0]) + " 00:00:00",
            endDate: _self.GetStandardStrTime(days[days.length - 1]) + " 23:59:59",
            type: 3
          })
          .catch(() => ({ code: -1 }))
          .then(res => {
            // sales[dayIdx][hour] / counts[dayIdx][hour]，dayIdx 与 days 对齐（旧→新）
            const sales = days.map(() => new Array(24).fill(0));
            const counts = days.map(() => new Array(24).fill(0));
            if (res && res.code === 0 && Array.isArray(res.data)) {
              res.data.forEach(row => {
                const m = String(row.orderDate || "").match(/^(\d{4}-\d{2}-\d{2})\s+(\d{1,2}):/);
                if (!m) {
                  return;
                }
                const di = dayIndex[m[1]];
                const h = parseInt(m[2], 10);
                if (di !== undefined && h >= 0 && h < 24) {
                  sales[di][h] += Number(row.sales) || 0;
                  counts[di][h] += Number(row.num) || 0;
                }
              });
            }
            _self.hodLoading = false;
            _self.renderHourHeatmap(days, sales, counts);
          });
      },
      renderHourHeatmap(days, sales, counts) {
        let _self = this;
        if (!hourChart) {
          return;
        }
        lastHourHeatmap = [days, sales, counts];
        const hourLabels = [];
        for (let h = 0; h < 24; h++) {
          hourLabels.push(h === 0 ? "12a" : h < 12 ? h + "a" : h === 12 ? "12p" : h - 12 + "p");
        }
        // y 轴：旧日期在下、今天在上（echarts y 轴自下而上）
        const dayLabels = days.map(d => _self.StringChangeWeek(_self.GetStandardStrTime(d)) + " " + (d.getMonth() + 1) + "/" + d.getDate());
        const data = [];
        let max = 0;
        let peak = null;
        for (let di = 0; di < days.length; di++) {
          for (let h = 0; h < 24; h++) {
            const v = sales[di][h];
            data.push([h, di, v ? Number(v.toFixed(2)) : 0]);
            if (v > max) {
              max = v;
            }
            if (v > 0 && (!peak || v > peak.v)) {
              peak = { v, di, h };
            }
          }
        }
        _self.hodPeak = peak
          ? dayLabels[peak.di] + " " + hourLabels[peak.h].replace("a", " AM").replace("p", " PM") + " (" + _self.$currency(peak.v) + ")"
          : "";
        const pal = _self.chartPalette();
        const splitArea = pal.splitArea ? { show: true, areaStyle: { color: pal.splitArea } } : { show: true };
        const axisStyle = { axisLabel: { color: pal.label }, axisLine: { lineStyle: { color: pal.line } } };
        hourChart.clear();
        if (max <= 0) {
          hourChart.setOption(_self.emptyChartOption(""));
          return;
        }
        hourChart.setOption({
          grid: { left: "3%", right: "3%", top: 12, bottom: 44, containLabel: true },
          tooltip: {
            ...pal.tooltip,
            position: "top",
            formatter: params => {
              const h = params.value[0];
              const di = params.value[1];
              return (
                dayLabels[di] +
                " · " +
                hourLabels[h] +
                "<br/>" +
                _self.$t("MachineProfit.xshoue") +
                ": " +
                _self.$currency(params.value[2]) +
                "<br/>" +
                _self.$t("MachineProfit.xsliang") +
                ": " +
                counts[di][h]
              );
            }
          },
          xAxis: { type: "category", data: hourLabels, splitArea, axisTick: { show: false }, ...axisStyle },
          yAxis: { type: "category", data: dayLabels, splitArea, axisTick: { show: false }, ...axisStyle },
          visualMap: {
            min: 0,
            max: max,
            calculable: true,
            orient: "horizontal",
            left: "center",
            bottom: 0,
            itemHeight: 90,
            inRange: { color: pal.heatColors },
            textStyle: { color: pal.label },
            formatter: v => _self.$currency(v)
          },
          series: [
            {
              type: "heatmap",
              data: data,
              emphasis: { itemStyle: { shadowBlur: 6, shadowColor: "rgba(0,0,0,0.3)" } }
            }
          ]
        });
      },
      //  待处理退款数（Refunds pending 提醒条）
      loadRefundPending() {
        let _self = this;
        this.$api
          .request(this.$url.RefundRecord.page, this.$method.get, { pageIndex: 1, pageSize: 100 })
          .then(res => {
            if (res.code === 0 && res.data) {
              const recs = res.data.records || [];
              _self.refundPending = recs.filter(r => r.rs === 0 || r.rs === -1).length;
            }
          })
          .catch(() => {});
      },
      //  相对时间：<1分钟=just now，<60分钟=Nm ago，<24小时=Nh ago，否则走现有 $formatDate
      relTime(t) {
        if (!t) {
          return "";
        }
        const then = new Date(t).getTime();
        if (isNaN(then)) {
          return "";
        }
        const diffMin = Math.floor((Date.now() - then) / 60000);
        if (diffMin < 1) {
          return this.$t("homeHub.justNow");
        }
        if (diffMin < 60) {
          return diffMin + "m ago";
        }
        const diffHr = Math.floor(diffMin / 60);
        if (diffHr < 24) {
          return diffHr + "h ago";
        }
        return this.$formatDate(t);
      },
      // 首页「最近出货」信息流：拉取最近已出货(payState=3)的交易
      loadRecentDeliveries() {
        let _self = this;
        // 静默刷新：仅首次加载展示 loading；数据未变化时不重渲染，避免信息流闪烁
        const initial = _self.recentDeliveries.length === 0;
        if (initial) {
          _self.deliveriesLoading = true;
        }
        _self.$api
          .request(_self.$url.Order.page, _self.$method.get, {
            payState: 3,
            pageIndex: 1,
            pageSize: 15,
            sort: "buyTime",
            order: "desc"
          })
          .then(res => {
            if (res.code === 0 && res.data) {
              const fresh = res.data.records || [];
              // 签名纳入所渲染字段（价格/图片/状态/时间），字段变化也会刷新，避免陈旧展示
              const sig = list =>
                list.map(r => [r.orderNumber, r.payablePrice, r.goodsUrl, r.payState, r.buyTime].join("~")).join("|");
              if (sig(fresh) !== sig(_self.recentDeliveries)) {
                _self.recentDeliveries = fresh;
              }
            }
            _self.deliveriesLoading = false;
          })
          .catch(() => {
            _self.deliveriesLoading = false;
          });
      },
      // 信息流：商品图（goodsUrl，可能逗号分隔多图取第一张）
      dFirstImg(url) {
        if (!url) {
          return "";
        }
        return String(url).split(",")[0].trim();
      },
      dImage(item) {
        const direct = this.dFirstImg(item.goodsUrl);
        if (direct) {
          return direct;
        }
        if (Array.isArray(item.ordersGoods)) {
          for (const g of item.ordersGoods) {
            const u = this.dFirstImg(g && g.goodsUrl);
            if (u) {
              return u;
            }
          }
        }
        return "";
      },
      dItemCount(item) {
        return Array.isArray(item.ordersGoods) ? item.ordersGoods.length : 0;
      },
      dItemImages(item) {
        if (!Array.isArray(item.ordersGoods)) {
          return [];
        }
        return item.ordersGoods.slice(0, 3).map(g => this.dFirstImg(g && g.goodsUrl));
      },
      dName(item) {
        if (this.dItemCount(item) > 1) {
          return this.$t("order.multiItem");
        }
        if (item.goodsName) {
          return item.goodsName;
        }
        if (Array.isArray(item.ordersGoods) && item.ordersGoods.length && item.ordersGoods[0].goodsName) {
          return item.ordersGoods[0].goodsName;
        }
        return "—";
      },
      //  排行榜类型排序
      handlerSortChange(e) {
        let _self = this;
        if (_self.activeName == "first") {
          _self.getSalesMachine();
        } else if (_self.activeName == "second") {
          _self.getSalesProduct();
          _self.getUserMachine();
        } else if (_self.activeName == "third") {
          _self.getSalesUser();
        }
      },
      //  中国标准时间转时间字符串
      GetStandardStrTimes(nS) {
        //  获取一个时间对象
        var date = new Date(nS);
        //  获取完整的年份(4位,1970)
        let y = date.getFullYear();
        //  获取月份(0-11,0代表1月,用的时候记得加上1)
        let m = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        //  获取日(1-31)
        let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        //  获取时(1-24)
        let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        //  获取分(1-60)
        let f = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        //  获取分(1-60)
        let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return y + "-" + m + "-" + d + " " + h + ":" + f + ":" + s;
      },
      //  用户榜
      getSalesUser(pageIndex) {
        let _self = this;
        _self.loading = true;
        _self.page.pageIndex = pageIndex ? pageIndex : 1;
        const reqPage = _self.page.pageIndex;
        let obj = _self.$cloud.objMerge(_self.search, _self.page);
        let url = _self.$url.Consoles.getSalesUser;
        let method = _self.$method.get;
        _self.$api
          .request(url, method, obj)
          .then(res => {
            _self.loading = false;
            if (res.code === 0) {
              let response = res.data;
              if (response.length > 0) {
                if (_self.page.pageIndex == 1) {
                  _self.datasets = response;
                } else {
                  for (let i = 0; i < response.length; i++) {
                    _self.datasets.push(response[i]);
                  }
                }
                _self.page.pageIndex++;
                if (response.length >= _self.page.pageSize) {
                  _self.ismore = 1;
                } else {
                  _self.ismore = 0;
                }
              } else if (reqPage > 1) {
                // 加载更多时下一页为空：保留已加载的列表，只提示没有更多
                _self.ismore = 0;
              } else {
                _self.datasets = [];
                _self.ismore = 0;
              }
            }
          })
          .catch(err => {
            _self.loading = false;
            _self.$notify({
              title: _self.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      //  商品榜
      getSalesProduct(pageIndex) {
        let _self = this;
        _self.loading = true;
        _self.page.pageIndex = pageIndex ? pageIndex : 1;
        const reqPage = _self.page.pageIndex;
        let obj = _self.$cloud.objMerge(_self.search, _self.page);
        let url = _self.$url.Consoles.getSalesProduct;
        let method = _self.$method.get;
        _self.$api
          .request(url, method, obj)
          .then(res => {
            _self.loading = false;
            if (res.code === 0) {
              let response = res.data;
              if (response.length > 0) {
                if (_self.page.pageIndex == 1) {
                  _self.datasets = response;
                } else {
                  for (let i = 0; i < response.length; i++) {
                    _self.datasets.push(response[i]);
                  }
                }
                _self.page.pageIndex++;
                _self.ismore = response.length >= _self.page.pageSize ? 1 : 0;
                //  商品统计条形图（画已加载的全部商品，加载更多后不丢前面的）
                let rows = _self.datasets;
                let xAxisData1 = [];
                let seriesData1 = [];
                for (let j = 0; j < rows.length; j++) {
                  let goodsName = rows[j]["goodsName"];
                  xAxisData1.push(goodsName);
                  let values = 0;
                  if (_self.weekcondition.searchType == "num") {
                    values = parseFloat(rows[j]["num"]);
                  } else if (_self.weekcondition.searchType == "sales") {
                    values = parseFloat(rows[j]["sales"]);
                  }
                  seriesData1.push(values);
                }
                var sptjChart = echarts.init(document.getElementById("ProductChart"), "macarons");
                const barPal = _self.chartPalette();
                var sptjOption = {
                  xAxis: {
                    type: "category",
                    data: xAxisData1,
                    axisLine: { lineStyle: { color: barPal.line } },
                    axisLabel: {
                      color: barPal.label,
                      // 加载更多后柱子会很多，标签自动隔开显示，避免重叠
                      interval: "auto",
                      formatter: function (value) {
                        // 如果标签长度超过8个字符，截断并添加省略号
                        if (value.length > 8) {
                          return value.substring(0, 8) + "...";
                        }
                        return value;
                      },
                      rotate: 0,
                      fontSize: 12
                    }
                  },
                  yAxis: {
                    type: "value",
                    axisLabel: { color: barPal.label },
                    splitLine: { lineStyle: { color: barPal.splitLine } }
                  },
                  series: [
                    {
                      data: seriesData1,
                      type: "bar"
                    }
                  ]
                };
                sptjOption && sptjChart.setOption(sptjOption);
              } else if (reqPage > 1) {
                // 加载更多时下一页为空：保留已加载的列表，只提示没有更多
                _self.ismore = 0;
              } else {
                _self.datasets = [];
                _self.ismore = 0;
                ProductChart.clear();
                ProductChart.setOption(_self.emptyChartOption());
              }
            }
          })
          .catch(err => {
            _self.loading = false;
            _self.$notify({
              title: _self.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      //  设备榜
      getSalesMachine(pageIndex) {
        let _self = this;
        _self.loading = true;
        _self.page.pageIndex = pageIndex ? pageIndex : 1;
        const reqPage = _self.page.pageIndex;
        let obj = _self.$cloud.objMerge(_self.search, _self.page);
        let url = _self.$url.Consoles.getSalesMachine;
        let method = _self.$method.get;
        _self.$api
          .request(url, method, obj)
          .then(res => {
            _self.loading = false;
            if (res.code === 0) {
              let response = res.data;
              if (response.length > 0) {
                if (_self.page.pageIndex == 1) {
                  _self.datasets = response;
                } else {
                  for (let i = 0; i < response.length; i++) {
                    _self.datasets.push(response[i]);
                  }
                }
                _self.page.pageIndex++;
                if (response.length >= _self.page.pageSize) {
                  _self.ismore = 1;
                } else {
                  _self.ismore = 0;
                }
              } else if (reqPage > 1) {
                // 加载更多时下一页为空：保留已加载的列表，只提示没有更多
                _self.ismore = 0;
              } else {
                _self.datasets = [];
                _self.ismore = 0;
              }
            }
          })
          .catch(err => {
            _self.loading = false;
            _self.$notify({
              title: _self.$t("common.tip"),
              message: err.msg,
              type: "error"
            });
          });
      },
      //  用户设备
      getUserMachine(pageIndex) {
        let _self = this;
        _self.$api
          .request(_self.$url.Theme.machinepage, _self.$method.get, {})
          .then(res => {
            if (res.code === 0) {
              let records = res.data.records;
              _self.MachineData = records;
              _self.MachinePage.totalSize = parseInt(res.data.total);
            }
          })
          .catch(() => {});
      }
    }
  };
</script>

<style lang="scss">
  /* 右侧最近销售列：显式对齐左侧堆叠图表列的实际渲染高度（homeLeftColHeight，
     mounted 中测量并在 resize 时刷新）——flex stretch 不可靠，因为右侧自身内容
     的高度也会参与拉伸基准的计算，反而把整行撑高。overflow: hidden 兜底，
     防止测量时机差异导致内容短暂溢出。卡片内部改用 flex 列布局，让信息流
     填满这个显式高度而不是按视口高度硬编码。 */
  .home-right-col {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .home-right-card {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;

    .el-tabs {
      display: flex;
      flex-direction: column;
      flex: 1;
      min-height: 0;
    }
    .el-tabs__content {
      flex: 1;
      min-height: 0;
    }
    /* 机器/商品排行在固定高度的列里，必须能滚动，否则下面的内容被裁掉看不到 */
    .el-tab-pane {
      height: 100%;
      overflow-y: auto;
    }
  }
  /* 最近销售信息流：填满标签页可用高度，内部滚动，避免撑高整页 */
  .deliv-feed {
    height: 100%;
    overflow-y: auto;
  }
  .deliv-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 4px;
    border-bottom: 1px solid var(--vtm-line);
  }
  .deliv-row:last-child {
    border-bottom: none;
  }
  .deliv-imgs {
    display: flex;
    align-items: center;
    gap: 3px;
    flex-shrink: 0;
  }
  .deliv-img {
    width: 40px;
    height: 40px;
    border-radius: var(--vtm-r-sm);
    background: var(--vtm-well);
    overflow: hidden;
  }
  .deliv-img--multi {
    width: 30px;
    height: 30px;
  }
  .deliv-ph {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: var(--vtm-ink-3);
    font-size: 16px;
    background: var(--vtm-well);
  }
  .deliv-meta {
    flex: 1;
    min-width: 0;
  }
  .deliv-name {
    font-size: 13px;
    font-weight: 600;
    color: var(--vtm-ink);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .deliv-sub {
    font-size: 11.5px;
    color: var(--vtm-ink-3);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 2px;
  }
  .deliv-right {
    flex-shrink: 0;
    text-align: right;
  }
  .deliv-amt {
    font-size: 14px;
    font-weight: 700;
    color: var(--vtm-heading);
  }
  .deliv-time {
    font-size: 11px;
    color: var(--vtm-ink-3);
    white-space: nowrap;
    margin-top: 2px;
  }
  .deliv-relt {
    font-size: 10.5px;
    color: var(--vtm-ink-3);
    white-space: nowrap;
    margin-top: 1px;
  }

  /* KPI strip — revenue-first stat cells + sparkline */
  .kpi-strip {
    display: flex;
    align-items: stretch;
    gap: 12px;
    margin-bottom: 15px;
  }
  .kpi-cell {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: var(--vtm-surface);
    border: 1px solid var(--vtm-line);
    border-radius: var(--vtm-r-md);
    padding: 14px 18px;
  }
  .kpi-hero {
    flex: 1.4;
    border-left: 3px solid var(--vtm-mint);
  }
  /* 分时段销售卡 */
  .hod-card {
    margin-top: 15px;
    padding: 12px 14px 8px;
    border: 1px solid var(--vtm-line);
    border-radius: 3px;
    background: var(--vtm-surface);
  }
  .hod-card__head {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 6px;
  }
  .hod-card__title {
    font-size: 16px;
    font-weight: bold;
    color: var(--vtm-ink-2);
  }
  .hod-card__peak {
    font-size: 12.5px;
    color: var(--vtm-mint-ink);
    font-weight: 600;

    i {
      margin-right: 3px;
    }
  }
  .hod-card__range {
    margin-left: auto;
    font-size: 12px;
    color: var(--vtm-ink-3);
  }
  .kpi-label {
    font-size: 11.5px;
    color: var(--vtm-ink-2);
    white-space: nowrap;
    margin-bottom: 6px;
  }
  .kpi-value {
    font-size: 20px;
    font-weight: 600;
    font-family: var(--vtm-display);
    color: var(--vtm-ink);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .kpi-hero .kpi-value {
    font-size: 28px;
  }
  .kpi-delta {
    display: flex;
    align-items: baseline;
    gap: 6px;
    font-size: 12px;
    margin-top: 6px;
  }
  .kpi-delta--up {
    color: var(--vtm-ok);
  }
  .kpi-delta--down {
    color: var(--vtm-crit);
  }
  .kpi-delta--flat {
    color: var(--vtm-ink-3);
  }
  .kpi-delta__label {
    color: var(--vtm-ink-3);
    font-weight: normal;
  }

  /* Attention chips — offline / faults / restock / refunds */
  .attn-row {
    display: flex;
    gap: 12px;
    margin-bottom: 15px;
  }
  .attn-chip {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    background: var(--vtm-well);
    border: 1px solid var(--vtm-line);
    border-radius: 999px;
    cursor: pointer;
    transition: background var(--vtm-speed), border-color var(--vtm-speed);
  }
  .attn-chip:hover {
    border-color: var(--vtm-line-2);
  }
  .attn-chip__icon {
    font-size: 16px;
    color: var(--vtm-ink-3);
  }
  .attn-chip__count {
    font-size: 15px;
    font-weight: 700;
    color: var(--vtm-ink);
  }
  .attn-chip__label {
    font-size: 12px;
    color: var(--vtm-ink-2);
    white-space: nowrap;
  }
  .attn-chip--crit {
    background: var(--vtm-crit-soft);
    border-color: var(--vtm-crit-soft);
  }
  .attn-chip--crit .attn-chip__icon,
  .attn-chip--crit .attn-chip__count {
    color: var(--vtm-crit);
  }
  .attn-chip--warn {
    background: var(--vtm-warn-soft);
    border-color: var(--vtm-warn-soft);
  }
  .attn-chip--warn .attn-chip__icon,
  .attn-chip--warn .attn-chip__count {
    color: var(--vtm-warn);
  }

  /* 趋势图工具条：弹性布局，可换行不裁切 */
  .trend-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px 14px;
    width: 100%;
    box-sizing: border-box;
    margin-top: 15px;
    padding: 8px 12px;
    background-color: var(--vtm-well);
    border: 1px solid var(--vtm-line);
    border-radius: 3px;
    min-height: 50px;
  }
  .trend-bar__title {
    font-size: 16px;
    white-space: nowrap;
  }
  .trend-bar__controls {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 14px;
    font-size: 14px;
  }
  .trend-bar__toggle {
    cursor: pointer;
    white-space: nowrap;
  }

  .activeyanse {
    color: var(--vtm-mint-ink);
  }

  .yanse {
    color: var(--vtm-ink);
  }

  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    // border-radius: 4px;
    min-height: 36px;
  }

  .row-bg {
    padding: 10px 0;
    background-color: var(--vtm-surface-2);
  }
</style>
